import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import { apiClient } from "../../services/apiClient";
import { useToast } from "../../Toaster/ToastContext";
import { jsPDF } from "jspdf";
import { applyPlugin } from "jspdf-autotable";

// Apply the autoTable plugin to jsPDF
applyPlugin(jsPDF);

const SalesReport = () => {

  const { showToast } = useToast();
  const [salesData, setSalesData] = useState([]);
  const [filteredSalesData, setFilteredSalesData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query); 

    const filtered = salesData.filter((item) =>
      (item.product_name || "").toLowerCase().includes(query.toLowerCase())
    );
    setFilteredSalesData(filtered);
  };

  const fetchSalesReport = async () => {
    try {
      const response = await apiClient.post(`/generateSaleReport`, { type: "preview" });
      if (response?.success && Array.isArray(response.data)) {
        setSalesData(response.data);
        setFilteredSalesData(response.data);
        if (response.data.length === 0) {
          showToast("No sales data found", "warning");
        }
      } else {
        setSalesData([]);
        setFilteredSalesData([]);
        showToast("No sales data found", "warning");
      }
    } catch (err) {
      console.error("Failed to fetch sales report:", err);
      showToast("Failed to fetch sales report", "error");
    }
  };

  useEffect(() => {
    fetchSalesReport();
  }, []);

  const handleExportExcel = async () => {
    try {
      const response = await apiClient.post(`/generateSaleReport`, {});
      const fileUrl = response?.path;

      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "sales-report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Sales report exported to Excel successfully", "success");
      } else {
        showToast("No file URL found in response", "error");
      }
    } catch (error) {
      console.error("Failed to export sales report to Excel:", error);
      showToast("Failed to export sales report to Excel", "error");
    }
  };

  const handleExportPDF = () => {
    try {
      const doc = new jsPDF();

      doc.setFontSize(20);
      doc.text("Sales Report", 14, 20);
      doc.setFontSize(12);
      doc.text("Generated on: July 30, 2025, 11:55 AM PKT", 14, 30);

      doc.autoTable({
        startY: 40,
        head: [["Product Name", "SKU", "Category", "Brand", "Sold Qty", "Sold Amount", "Instock Qty"]],
        body: filteredSalesData.map((item) => [ 
          item.product_name || "N/A",
          item.sku || "N/A",
          item.category || "N/A",
          item.brand || "N/A",
          item.sold_qty || "0",
          item.sold_amount ? `$${parseFloat(item.sold_amount).toFixed(2)}` : "N/A",
          item.in_stock_qty || "0",
        ]),
        theme: "grid",
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: { fillColor: [100, 100, 100], textColor: [255, 255, 255] },
        alternateRowStyles: { fillColor: [240, 240, 240] },
        margin: { top: 40 },
      });

      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(`Page ${i} of ${pageCount}`, 190, 285, { align: "right" });
      }

      doc.save("sales-report.pdf");
      showToast("Sales report exported to PDF successfully", "success");
    } catch (error) {
      console.error("Failed to export PDF:", error);
      showToast("Failed to export sales report to PDF", "error");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Sales Report"
          subtitle="Manage Your Sales Report"
          onExcelClick={handleExportExcel}
          onPDFClick={handleExportPDF}
        />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table datanew">
                <thead>
                  <tr>
                    <th>Product Name</th>
                    <th>SKU</th>
                    <th>Category</th>
                    <th>Brand</th>
                    <th>Sold Qty</th>
                    <th>Sold Amount</th>
                    <th>Instock Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredSalesData.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No sales data found.
                      </td>
                    </tr>
                  ) : (
                    filteredSalesData.map((item) => (
                      <tr key={item.product_id}>
                        <td className="productimgname">
                          {item.product_name || "N/A"}
                        </td>
                        <td>{item.sku || "N/A"}</td>
                        <td>{item.category || "N/A"}</td>
                        <td>{item.brand || "N/A"}</td>
                        <td>{item.sold_qty || "0"}</td>
                        <td>{item.sold_amount ? `$${parseFloat(item.sold_amount).toFixed(2)}` : "N/A"}</td>
                        <td>{item.in_stock_qty || "0"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesReport;